// ===================================================
// FOTOS — OS (Ordens de Serviço)
// ===================================================
function renderOSFotosGrid(){
  const grid = document.getElementById('os-fotos-grid');
  if(!grid) return;
  if(!_osFotosTemp||!_osFotosTemp.length){
    grid.innerHTML='<div style="color:var(--muted);font-size:12px;padding:8px 0">Nenhuma foto adicionada</div>';
    return;
  }
  grid.innerHTML = _osFotosTemp.map((p,i)=>`
    <div style="position:relative;width:80px;height:80px;border-radius:8px;overflow:hidden;border:1px solid var(--border);flex-shrink:0" id="osfoto-${i}">
      <img src="" style="width:100%;height:100%;object-fit:cover" loading="lazy">
      <button onclick="osFotoRemover(${i})" style="position:absolute;top:2px;right:2px;background:#f06595;color:#fff;border:none;border-radius:50%;width:18px;height:18px;font-size:11px;cursor:pointer;line-height:18px;padding:0">×</button>
    </div>`).join('');
  _osFotosTemp.forEach((p,i)=>{
    dbxGetThumbnailUrl(p).then(url=>{
      const img = document.querySelector('#osfoto-'+i+' img');
      if(img&&url) img.src=url;
    }).catch(()=>{});
  });
}

function osFotoRemover(i){
  _osFotosTemp.splice(i,1);
  renderOSFotosGrid();
}

async function osUploadFoto(){
  if(!await dbxEnsureToken()){toast('Conecte o Dropbox primeiro','error');return;}
  const input=document.createElement('input');
  input.type='file';input.accept='image/*';input.multiple=true;
  input.onchange=async()=>{
    const files=[...input.files];
    if(!files.length) return;
    const osId=document.getElementById('osid')?.value||'novo';
    const mesAno=new Date().toISOString().slice(0,7);
    const btn=document.getElementById('os-foto-btn');
    if(btn){btn.disabled=true;btn.textContent='⏳ Enviando...';}
    for(const file of files){
      const ext=file.name.split('.').pop()||'jpg';
      const ts=Date.now();
      const path=`/OS/${mesAno}/${osId}_${ts}.${ext}`;
      try{
        const result=await dbxUploadFile(path,file);
        if(result&&!result.error_summary){
          _osFotosTemp.push(path);
          renderOSFotosGrid();
        } else { toast('Erro ao enviar foto','error'); }
      } catch(e){ toast('Erro no upload: '+e.message,'error'); }
    }
    if(btn){btn.disabled=false;btn.textContent='📷 Adicionar foto';}
  };
  input.click();
}

